import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { Subject, takeUntil } from "rxjs";
import { map } from "rxjs/operators";
import { VirkeskopBlobStorageTyp } from "~app/common/models/constants";
import { canEdit } from "~app/role-permissions";
import { ObjectUtils } from "../../../../common/utils/object-utils";
import { KontraktDokumentComponent } from "../../kontrakt/kontrakt-dokument/kontrakt-dokument.component";
import { Atgard } from "../../models/atgard-models";
import { AtgardMediatorService } from "../../services/atgard-mediator.service";
import { KontraktDokumentService } from "../../services/kontrakt-dokument.service";
import { KontraktMediatorService } from "../../services/kontrakt-mediator.service";
@Component({
    selector: "rask-atgard-avverkningsanmalan-samrad",
    templateUrl: "./atgard-avverkningsanmalan-samrad.component.html",
    styleUrl: "./atgard-avverkningsanmalan-samrad.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RadiobuttonGroupComponent,
        FormsModule,
        ButtonComponent,
        KontraktDokumentComponent
    ]
})
export class AtgardAvverkningsanmalanSamradComponent implements OnInit, OnDestroy {
    protected atgard: Atgard;
    protected avverkningsanmalanButtonsVisible = true;
    protected avverkningsanmalanKravs: boolean;
    protected blobStorageDokumentTypAvverkningsanmalanSamradBilaga = VirkeskopBlobStorageTyp.AvverkningsanmalanSamradBilaga;
    protected cancelButtonVisible = false;
    protected enableDeleteFile = false;
    protected fileUploadVisible = false;
    protected kontraktReadonly: boolean;

    private readonly atgardMediatorService = inject(AtgardMediatorService);
    private readonly kontraktDokumentService = inject(KontraktDokumentService);
    private readonly kontraktMediatorService = inject(KontraktMediatorService);
    private readonly ngOnDestroy$ = new Subject<void>();

    private readonly canEdit = canEdit();

    constructor() {
        this.atgardMediatorService.atgard$.pipe(
            takeUntil(this.ngOnDestroy$)
        ).subscribe(atgard => {
            this.atgard = atgard;
            this.avverkningsanmalanKravs = this.atgard.avverkningsanmalanKravs;
            this.enableDeleteFile = !this.atgard.isTillgangligt;
        });
    }

    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    ngOnInit(): void {
        this.kontraktMediatorService.isReadonly$.pipe(
            map(readonly => readonly || !this.canEdit()),
            takeUntil(this.ngOnDestroy$)).subscribe(readonly => this.kontraktReadonly = readonly);
        if(this.avverkningsanmalanKravs) {
            this.handleExistingDocuments();
        }
    }

    onAvverkningsanmalanKravsChange(val: boolean) {
        if (!ObjectUtils.isNullOrUndefined(val)) {
            this.atgard.avverkningsanmalanKravs = val;
            this.atgardMediatorService.update(this.atgard);
            if (!val) {
                this.fileUploadVisible = false;
            }
        }
    }

    onCancelClick() {
        this.fileUploadVisible = false;
    }

    onContinueClick() {
        this.fileUploadVisible = true;
    }

    protected onFileUpload() {
        this.avverkningsanmalanButtonsVisible = false;
    }

    private async handleExistingDocuments() {
        const dokument = await this.kontraktDokumentService.getDokumentForAtgard(this.atgard.id, this.blobStorageDokumentTypAvverkningsanmalanSamradBilaga);
        if(dokument.length > 0) {
            // Är en fil uppladdad så bör man bli låst till det valet
            this.avverkningsanmalanButtonsVisible = false;
            this.fileUploadVisible = true;
        }
    }
}
